"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const next13_enums_colors_1 = __importDefault(require("@gerenciatd/next13.enums.colors"));
const SolIconM = (props) => {
    let { color } = props;
    let layoutSize = {};
    if (props.layoutSize) {
        ({ layoutSize } = props);
    }
    let { width, height, insetPosition } = props;
    const size = {};
    /* damos valor a la otra coordenada en caso de no indicarse */
    if (width && width !== "auto") {
        size.width = width;
        if (!layoutSize.width) {
            layoutSize.width = width;
        }
    }
    if (height && height !== "auto") {
        size.height = height;
        if (!layoutSize.height) {
            layoutSize.height = height;
        }
    }
    const fill = (0, next13_enums_colors_1.default)(color);
    return (react_1.default.createElement("div", { className: "svg-layout-size", style: Object.assign({}, layoutSize) },
        react_1.default.createElement("svg", Object.assign({ focusable: "false", viewBox: "0 0 500 500" }, size, { style: Object.assign({}, insetPosition), fill: fill, "aria-label": "", "aria-hidden": "true", role: "presentation" }),
            react_1.default.createElement("g", null,
                react_1.default.createElement("g", { transform: "translate(-222.000000, -2980.000000)" },
                    react_1.default.createElement("path", { d: "M480.5,3386h-15.1c-43-0.6-142.8-16.6-142.8-153.4c0-136.5,98.9-152.2,141.5-152.6h3    c4.3,0,8.6,0,12.4,0.2c43.3,1.1,143.6,18,143.6,153.2C623.3,3368.6,523.5,3385.1,480.5,3386 M711.2,3218h-63.8    c-1.1,0-2.1,0.4-3.3,0.6c-2.8-48.8-18.1-83-39.1-106.6c0.4-0.2,0.9-0.4,1.1-0.6l46.2-45.8c4.1-4.3,4.1-11.1,0-15.2    c-4.3-4.3-11.2-4.3-15.3,0l-46.2,45.8c-0.2,0.4-0.4,0.9-0.6,1.1c-38.5-32.1-86.6-37.6-107.4-38.5v-68.1c0-6-4.9-10.7-10.7-10.7    c-6,0-10.7,4.7-10.7,10.7v68.1c-21.3,0.4-68.8,5.3-106.6,37.4c-0.4-0.4-0.6-0.9-1.1-1.3l-44.7-44.5c-4.1-4.3-11-4.3-15.1,0    c-4.3,4.1-4.3,10.9,0,15.2l44.7,44.5c0.4,0.2,0.9,0.4,1.3,0.9c-20.4,23.5-35.5,58-38.1,107.7c-0.9-0.2-1.7-0.6-2.6-0.6h-66.4    c-6,0-10.7,4.9-10.7,10.7c0,6,4.8,10.7,10.7,10.7h66.4c0.9,0,1.5-0.2,2.2-0.4c1.3,50.1,15,85.2,34.4,110c-0.4,0.2-0.9,0.4-1.3,0.9    l-44.5,44c-4.1,4.3-4.1,11.2,0,15.2c2.1,2.1,4.9,3.2,7.5,3.2c2.6,0,5-1.1,6.9-2.6c1.7-0.6,3.2-1.3,4.5-2.6l40.6-40.4    c0.4-0.4,0.6-1.1,1.1-1.7c38.3,35.3,88.1,41.5,110.7,42.3v61.9c0,5.8,4.8,10.7,10.7,10.7c5.8,0,10.7-4.9,10.7-10.7v-61.9    c21.1-0.6,72.9-6.4,112.3-42.6c0.4,0.6,0.9,1.5,1.5,2.1l40.4,40.3c2.2,2.1,4.8,3,7.5,3c2.8,0,5.6-0.9,7.8-3    c4.1-4.3,4.1-10.9,0-15.2l-40.6-40.3c-0.6-0.9-1.5-1.3-2.6-1.7c20.2-24.8,34.4-60.3,35.5-111c0.9,0.2,1.7,0.4,2.8,0.4h63.8    c6,0,10.7-4.7,10.7-10.7C722,3222.9,717.3,3218,711.2,3218" }))))));
};
exports.default = SolIconM;
//# sourceMappingURL=index.js.map